import * as React from 'react';
import { cn } from '../lib/utils';
import { fieldClassName, useFieldControl } from '../lib/field';

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(fieldClassName, 'flex min-h-[96px] px-3 py-2 leading-6', className)}
      {...useFieldControl(props)}
    />
  )
);

Textarea.displayName = 'Textarea';
